import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

const KEY = ['settings', 'roles'];

export function useRoles() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get('/roles');
      return data?.roles || data?.data || data || [];
    },
    staleTime: 30_000
  });
}

export { KEY as ROLES_KEY };
